module.exports = __webpack_public_path__ + "img/blanket_finished.39cd841a.png";